import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Attach token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("solaro_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth
export const registerUser = (data) => api.post("/auth/register", data);
export const loginUser = (data) => api.post("/auth/login", data);
export const getMe = () => api.get("/auth/me");
export const updateProfile = (data) => api.put("/auth/profile", data);

// Bottles
export const getBottles = () => api.get("/bottles");
export const selectBottle = (bottle_number) => api.post("/bottles/select", { bottle_number });
export const addBottle = (bottle_number) => api.post("/bottles/add", { bottle_number });
export const addRandomBottle = () => api.post("/bottles/add-random");
export const releaseBottle = (bottle_number) => api.post("/bottles/release", { bottle_number });
export const refreshHold = () => api.post("/bottles/refresh-hold");

// Referral
export const sendReferral = (data) => api.post("/referral/send", data);

// Waitlist
export const joinWaitlist = (data) => api.post("/waitlist/join", data);
export const getWaitlistStatus = () => api.get("/waitlist/status");

// Checkout
export const createCheckout = (data) => api.post("/checkout/create", data);
export const checkPaymentStatus = (session_id) => api.get(`/checkout/status/${session_id}`);

// Reservations
export const getReservations = () => api.get("/user/reservations");

// Admin
export const adminLogin = (password) => api.post("/admin/login", { password });
export const getAdminDashboard = () => api.get("/admin/dashboard");
export const getAdminReservations = () => api.get("/admin/reservations");
export const getAdminBottles = () => api.get("/admin/bottles");
export const updateBottleCount = (total_bottles) => api.post("/admin/bottles/update-count", { total_bottles });
export const adminConfirmBottle = (bottle_number) => api.post("/admin/bottles/confirm", { bottle_number });
export const adminReleaseBottle = (bottle_number) => api.post("/admin/bottles/release", { bottle_number });
export const adminUpdateUser = (data) => api.put("/admin/users/update", data);
export const adminAssignBottle = (user_id, bottle_number) => api.post("/admin/bottles/assign", { user_id, bottle_number });
export const adminSetMaxBottles = (user_id, max_bottles) => api.put("/admin/users/max-bottles", { user_id, max_bottles });
export const getAdminExport = () => api.get("/admin/export");

export default api;
